import React from 'react'
import { NavLink as NavLinkRouter} from 'react-router-dom'

const NavLink = (props) => {
  return <NavLinkRouter {...props} activeClassName="nav_a"/>
};

export default NavLink;